import * as React from "react";
function SvgTune(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      ref={svgRef}
      {...props}
    >
      <path
        d="M3.4 15.8c-.2 0-.4-.1-.6-.3-.2-.2-.3-.4-.3-.6s.1-.4.3-.6c.2-.2.4-.3.6-.3h3.4c.2 0 .4.1.6.3.2.2.3.4.3.6s-.1.4-.3.6c-.2.2-.4.3-.6.3H3.4zm0-9.9c-.2 0-.4-.1-.6-.3-.2-.1-.3-.3-.3-.6 0-.2.1-.4.3-.6.2-.2.4-.3.6-.3h6.5c.2 0 .4.1.6.3.2.2.3.4.3.6 0 .2-.1.4-.3.6-.2.2-.4.3-.6.3H3.4zm6.7 11.6c-.2 0-.4-.1-.6-.3-.2-.2-.3-.4-.3-.6v-3.3c0-.2.1-.4.3-.6.2-.2.4-.3.6-.3.2 0 .4.1.6.3s.3.4.3.6v.8h5.7c.2 0 .4.1.6.3.2.2.3.4.3.6s-.1.4-.3.6c-.2.2-.4.3-.6.3H11v.8c0 .2-.1.4-.3.6-.2.1-.4.2-.6.2zm-3.3-5c-.2 0-.4-.1-.6-.3-.2-.2-.3-.4-.3-.6v-.8H3.4c-.2 0-.4-.1-.6-.3-.2-.2-.3-.4-.3-.6s.1-.4.3-.6c.2-.2.4-.3.6-.3h2.5v-.6c0-.2.1-.4.3-.6.2-.2.4-.3.6-.3.2 0 .4.1.6.3.2.2.3.4.3.6v3.3c0 .2-.1.4-.3.6-.2.2-.4.2-.6.2zm3.3-1.6c-.2 0-.4-.1-.6-.3-.2-.2-.3-.4-.3-.6s.1-.4.3-.6c.2-.2.4-.3.6-.3h6.5c.2 0 .4.1.6.3.2.2.3.4.3.6s-.1.4-.3.6c-.2.2-.4.3-.6.3h-6.5zm3.1-3.3c-.2 0-.4-.1-.6-.3-.2-.2-.3-.4-.3-.6V3.4c0-.2.1-.4.3-.6.2-.2.4-.3.6-.3s.4.1.6.3c.2.2.3.4.3.6v.8h2.5c.2 0 .4.1.6.3.2.2.3.4.3.6 0 .2-.1.4-.3.6-.2.2-.4.3-.6.3h-2.5v.8c0 .2-.1.4-.3.6-.2.1-.4.2-.6.2z"
        fill="#28bbbb"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgTune);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
